"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'and-options',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        players: {
            type: Array,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    data() {
        return {
            responded: this.playerinput.options.map(() => undefined),
        };
    },
    methods: {
        playerFactorySaved(idx) {
            return (out) => {
                this.responded[idx] = out;
            };
        },
        canSave() {
            const refs = this.$refs.childInputs;
            if (!refs)
                return true;
            for (const child of refs) {
                if (child.canSave instanceof Function) {
                    if (child.canSave() === false) {
                        return false;
                    }
                }
            }
            return true;
        },
        saveData() {
            if (this.canSave() === false) {
                alert('Not all options selected');
                return;
            }
            const refs = this.$refs.childInputs;
            if (refs) {
                for (const child of refs) {
                    if (child.saveData instanceof Function) {
                        child.saveData();
                    }
                }
            }
            this.onsave({
                type: 'and',
                responses: this.responded,
            });
        },
    },
});
